import { datadogRum } from '@datadog/browser-rum';
import { FaceValidationResult, FaceValidationStatus } from './get-face-validation-result';

/** The flow in which a template-evolved face was detected. */
export type TemplateEvolvedFlow = 'load' | 'save' | 'editor';

/**
 * Intentionally log a recoverable template-evolved divergence to Datadog RUM.
 *
 * Called by load, save, and editor-view validation paths when a card face has
 * fewer permanent objects than the current template requires (typically because
 * the template evolved after the project was saved). This is a recoverable
 * state — callers should continue the user's flow and not throw or trigger a
 * system-failure dialog.
 *
 * No-op for any status other than `TemplateEvolved` so callers can pass every
 * result through this without an extra branch.
 *
 * @param flow - which application flow observed the divergence
 * @param result - the structured validation result to log
 */
export const logTemplateEvolvedFace = (flow: TemplateEvolvedFlow, result: FaceValidationResult): void => {
  if (result.status !== FaceValidationStatus.TemplateEvolved) {
    return;
  }
  datadogRum.addAction('card-face-template-evolved', {
    flow,
    faceId: result.faceId,
    templateCount: result.templateCount,
    permanentCount: result.permanentCount,
    delta: result.delta,
  });
};
